import * as dateMath from 'date-arithmetic';

export class DateBuilder
{
    date:Date 

    constructor(
        date:Date
    ){
        this.date = new Date(date);
    }

    static now(){
        return new DateBuilder(new Date());
    }

    addYears(amount:number){ 
        return new DateBuilder(
            dateMath.add(this.date, amount, 'year')
        ) 
    }

    addMonths(amount:number){ 
        return new DateBuilder(
            dateMath.add(this.date, amount, 'month')
        ) 
    }

    addDays(amount:number){ 
        return new DateBuilder(
            dateMath.add(this.date, amount, 'day')
        ) 
    }

    addHours(amount:number){ 
        return new DateBuilder(
            dateMath.add(this.date, amount, 'hours')
        ) 
    }

    addMinutes(amount:number){ 
        return new DateBuilder(
            dateMath.add(this.date, amount, 'minutes')
        ) 
    }

    addSeconds(amount:number){ 
        return new DateBuilder(
            dateMath.add(this.date, amount, 'seconds')
        ) 
    }

    

    addMilliseconds(amount:number){ 
        return new DateBuilder(
            dateMath.add(this.date, amount, 'milliseconds')
        ) 
    }

    zeroMinutes(){
        return new DateBuilder(
            new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), this.date.getHours(), 0, 0, 0)
        )
    }

    zeroSeconds(){
        return new DateBuilder(
            new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), this.date.getHours(), this.date.getMinutes(), 0, 0)
        )
    }

    zeroMilliseconds(){
        return new DateBuilder(
            new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), this.date.getHours(), this.date.getMinutes(), this.date.getSeconds(), 0)
        )
    }
}